import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { useTheme } from 'providers/Theme.provider';

import IMG_CLOUD from 'assets/images/icons/carbon-cloud-offline.svg';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import beSendClientStatus from 'booking/beSendClientStatus.action';

import CN from './ClientStatusChecker.module.scss';

const L = logger('ClientStatusChecker');

const ClientStatusChecker = ({ cognito, salonId, onBlocked, isBlocked, salonDetails, dispatch }) => {
  const [message, setMessage] = useState('');

  const { isDarkMode, isNeutralMode } = useTheme();

  const { phone: salonPhone } = asObject(salonDetails);

  const componentClasses = cn({
    [CN.component]: true,
    [CN.dark]: isDarkMode,
    [CN.neutral]: isNeutralMode,
  });

  useEffect(() => {
    if (isBlocked) return;
    if (!cognito?.user?.username || !salonId) return;

    const checkStatus = async () => {
      try {
        const result = await dispatch(
          beSendClientStatus({
            salonId,
            cognitoUserName: cognito?.user?.username,
          }),
        );

        if (result?.errorMessage || result.responseStatus === 403) {
          onBlocked?.();

          setMessage('Unfortunately this business does not currently accept Online Booking.');
          L.debug('useEffect()', result?.errorMessage);
        }
      } catch (err) {
        L.debug('useEffect()', err);
      }
    };

    checkStatus();
  }, [cognito, salonId, dispatch, onBlocked, isBlocked]);

  return (
    <div data-bem="ClientStatusChecker" className={componentClasses}>
      <div className={CN.statusIcon}>
        <img src={IMG_CLOUD} alt="offline icon" />
      </div>
      <div className={CN.title}>{message}</div>
      <div className={CN.text}>
        If you would like to make an appointment then please contact them on:
        <span className={CN.phone}>{salonPhone}</span>
      </div>
    </div>
  );
};

export const mapStateToProps = state => ({
  salonDetails: state?.booking?.salonDetails,
});

export default connect(mapStateToProps)(ClientStatusChecker);
